import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'easyroute-modal-cost-delete',
  templateUrl: './modal-cost-delete.component.html',
  styleUrls: ['./modal-cost-delete.component.scss']
})
export class ModalCostDeleteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
